import { render, staticRenderFns } from "./CreateTaxNumber.vue?vue&type=template&id=330b8af8"
import script from "./CreateTaxNumber.vue?vue&type=script&lang=js"
export * from "./CreateTaxNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports